<ng-template elderToolbarColumn="right.actions">
  <app-facility-context-menu></app-facility-context-menu>
</ng-template>

<div class="layout-col full">
  <app-work-station-browser
    class="flex"
    [facility]="facilityId$ | async"
  ></app-work-station-browser>
</div>
